<template>
  <div class="business-info-entry">
    <z-fix-top keep-position class="fixtop" headerTaskbarBG="#F8F8F8">
      <z-nav-bar class="navbar" left-arrow title="监督举报" style="background: #F8F8F8" @click-left="closePage">
      </z-nav-bar>
    </z-fix-top>
    <div v-if="reportSource == 'doorRecycling'">
      <section class="cell">
        <z-cell-group inset>
          <z-cell class="titleboldTop" title="违规举报" label="*违规举报经核实后，最高5000元现金奖励" label-class="titleLabelClass"/>
          <div v-for="item in illegalList" :key="item.title">
            <z-cell :title="item.title" @click="toSubmit(item.jumpPage, item.title)" :label="item.desc" is-link title-class="leftCellTitle"/>
          </div>
        </z-cell-group>
      </section>
      <div v-if="(complaintList || []).length">
        <section class="cell">
          <z-cell-group inset>
            <z-cell class="titlebold" title="服务投诉" />
            <div v-for="item in complaintList" :key="item.title">
              <z-cell :title="item.title" @click="toSubmit(item.jumpPage, item.title)" :label="item.desc" is-link title-class="leftCellTitle"/>
            </div>
          </z-cell-group>
        </section>
      </div>
    </div>
    <div v-if="reportSource == 'storeRecycling'">
        <section class="cell">
          <z-cell-group inset>
            <z-cell class="titlebold" title="举报类型" />
            <div v-for="item in [...illegalList, ...complaintList]" :key="item.title">
              <z-cell :title="item.title" @click="toSubmit(item.jumpPage, item.title)" :label="item.desc" is-link title-class="leftCellTitle"/>
            </div>
          </z-cell-group>
        </section>
      </div>
  </div>
</template>
<script>
import native from '@zz-common/native-adapter';
import { FixTop, NavBar, Cell, CellGroup } from '@zz-common/zz-ui'
import { getCaseTrackReportConfig } from '@api/resourceApi'
import { lego } from '@zz-common/lego'
import { queryParams, getCookie } from '@lib/utils';

const query = queryParams()

export default {
  name: 'Supervise',
  data() {
    return {
      reportSource: query.reportSource || this.$route.query.reportSource,
      orderId: query.orderId || this.$route.query.orderId,
      appointmentId: query.appointmentId || this.$route.query.appointmentId,
      illegalList: [],
      complaintList: []
    };
  },
  computed: {},
  methods: {
    closePage() {
      native.close();
    },
    toSubmit(jumpPage, reportType) {
      if (jumpPage == 'null') {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/supervise/commit?orderId=${this.orderId}&reportSource=${this.reportSource}&reportType=${encodeURI(reportType)}${this.appointmentId ? `&appointmentId=${this.appointmentId}` : ''}`,
          needClose: 1
        })
      } else {
        native.skipToUrl({
          targetUrl: jumpPage,
          needClose: 1
        })
      }
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    getCaseTrackReportConfig().then(res => {
      this.illegalList = (res[this.reportSource]?.reportType || []).filter(item => item.title != '服务问题');
      this.complaintList = (res[this.reportSource]?.reportType || []).filter(item => item.title == '服务问题');
    })
    lego.send({
      pagetype: 'SUPERVISE',
      actiontype: 'ENTRY_SELECT_PAGE',
      backup: {
        uid: getCookie('uid')
      }
    })
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-cell': Cell,
    'z-cell-group': CellGroup
  }
};
</script>

<style lang='less' scoped>
@import "index.less";
</style>
